import { viewTexts } from '../constants/view-texts';

const vt = viewTexts.tusUploader;

/**
 *
 * error example:
 *
 * Error: tus: unexpected response while creating upload, originated from request (response code: 400, response text: {"upload_metadata":["Cannot accept filetype \"image/jpeg\"."]})
 */

export type CustomTusErrorType = {
  type: 'filetype-error' | 'others';
  message: string;
};

export const tusErrorMessageConverter = (
  errorMsg: string
): CustomTusErrorType => {
  const findPos = errorMsg.search('Cannot accept filetype');
  if (findPos === -1) {
    return {
      type: 'filetype-error',
      message: vt.otherError
    };
  } else {
    if (errorMsg.includes('image/jpeg', findPos)) {
      return {
        type: 'filetype-error',
        message: vt.jpegError
      };
    }
    return {
      type: 'filetype-error',
      message: vt.otherFiletypeError
    };
  }
};
